<!--Modals-->
<app-deprecated-confirmation-dialog
    #confirmTaskDeleteDialog
    [label]="'Delete'"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<app-deprecated-modal #taskDetailsModal [centered]="true">
    <app-deprecated-task-details #taskDetailsModal [task]="currentTask" (done)="onDone()"></app-deprecated-task-details>
</app-deprecated-modal>

<app-deprecated-modal #pdfPreviewModal tall="true">
    <app-pdf-viewer #pdfViewer></app-pdf-viewer>
</app-deprecated-modal>

<!--Body-->
<div class="task-container scroll" *ngIf="tasks.length" (scroll)="onScrollContainer()" #container>
    <div class="task" *ngFor="let task of tasks; let i = index">
        <form #form="ngForm">
            <div class="wrapper margin-x-2">
                <!--Hidden elm-->
                <input
                    name="file{{ i }}"
                    type="hidden"
                    [(ngModel)]="task.fileId"
                    [required]="task.isAttachmentRequired"
                />

                <div class="check">
                    <mat-checkbox
                        [checked]="task.isComplete()"
                        (click)="onToggleTaskComplete($event, task, form)"
                    ></mat-checkbox>
                </div>

                <div class="main">
                    <!--Task name-->
                    <div class="name">
                        <span [class.complete]="task.isComplete()">{{ task.name }}</span>
                    </div>

                    <!--Assignment name-->
                    <div class="assignment">
                        <span *ngIf="task.taskType === 'onboarding' && task.subject">
                            {{ task.subject.fullName }}'s onboarding
                        </span>
                        <span *ngIf="task.taskType === 'offboarding' && task.subject">
                            {{ task.subject.fullName }}'s offboarding
                        </span>

                        <ng-container>
                            - {{ task.assignee ? 'Assigned to ' + task.assignee.fullName : 'Unassigned' }}
                        </ng-container>
                    </div>

                    <!--Due/Completed date-->
                    <ng-container *ngIf="!task.isComplete()">
                        <div class="dueAt" *ngIf="task.dueAt; else noDueDate">Due {{ task.dueAt | appDate }}</div>
                        <ng-template class="dueAt" #noDueDate> No Due Date </ng-template>
                    </ng-container>

                    <ng-container *ngIf="task.isComplete()">
                        <div class="completedAt">
                            Completed {{ task.completedBy?.id ? 'by ' + task.completedBy.fullName : '' }} on
                            {{ task.completedAt | appDate }}
                        </div>
                    </ng-container>

                    <!--File-->
                    <div class="attachFile" *ngIf="task.isAttachmentRequired && !task.fileId">
                        <app-file-drop
                            (filesSelected)="onFileSelected($event, task)"
                            [inlineView]="true"
                            [allowedTypes]="allowedFileTypes"
                            [required]="true"
                        ></app-file-drop>
                    </div>
                    <!--Error message-->
                    <mat-error *ngIf="form.submitted && form.invalid">File Attachment is required. </mat-error>
                    <div
                        class="attachFile"
                        *ngIf="task.isAttachmentRequired && task.fileId"
                        (click)="viewFile(task.file)"
                    >
                        <label
                            ><span>{{ task.filename }}</span></label
                        >
                        <img class="cross-img" (click)="onFileRemoved(task)" appIcon="CrossBlueUiOutline" />
                    </div>
                </div>

                <div class="push">
                    <ng-container *ngIf="!task.isComplete()">
                        <ui-badge *ngIf="task.isPastDue()"> PAST DUE </ui-badge>

                        <!--Non-Admin Meatball menu-->
                        <ng-container *ngIf="onDashboard && !isAdmin; else meatballMenu">
                            <button
                                class="material-meatball-menu-button meatball-icon-border"
                                [matMenuTriggerFor]="menu"
                            >
                                <img appIcon="MeatballSolid" />
                            </button>
                            <mat-menu #menu="matMenu" xPosition="before">
                                <button mat-menu-item (click)="onView(task)">View</button>
                            </mat-menu>
                        </ng-container>

                        <!--Admin Meatball menu-->
                        <ng-template #meatballMenu>
                            <button
                                class="material-meatball-menu-button meatball-icon-border"
                                [matMenuTriggerFor]="menu"
                            >
                                <img appIcon="MeatballSolid" />
                            </button>
                            <mat-menu #menu="matMenu" xPosition="before">
                                <button *ngIf="task.assignee" mat-menu-item (click)="onRemind(task)">Remind</button>
                                <button mat-menu-item (click)="onEdit(task)">Edit</button>
                                <button mat-menu-item (click)="onDelete(task)">Delete</button>
                            </mat-menu>
                        </ng-template>
                    </ng-container>
                </div>
            </div>
        </form>
    </div>
</div>
